// ค่าเริ่มต้นของ formTwoData / checkDiffFormTwoData
// เดิมมี 2 ก้อนที่เหมือนกันทุกตัวใน EditEvaluateForm (formTwoData, checkDiffFormTwoData)
// และอีกก้อนที่ EvaluateForm ใช้ (ไม่มี evaluate_salary_behavior_id / step_active)
// รวมเป็น factory เดียว extended=true จะได้ฟิลด์เพิ่มสำหรับหน้าที่ต้องอ้างอิง record เดิม (edit/manage)
const BASE_ROWS_OLD = [
  { id: 1, label: "การมุ่งผลสัมฤทธิ์", percentage: 20, no: 2 },
  { id: 2, label: "การบริการที่ดี", percentage: 20, no: 3 },
  { id: 3, label: "การสั่งสมความเชี่ยวชาญ", percentage: 20, no: 4 },
  { id: 4, label: "ความยึดมั่นในความถูกต้อง", percentage: 20, no: 5 },
  { id: 5, label: "การทำงานเป็นทีม", percentage: 20, no: 6 },
];

const BASE_ROWS = [
  { id: 1, label: "การทำงานที่เป็นเลิศ", percentage: 25, no: 2 },
  { id: 2, label: "การยึดมั่นในความถูกต้องและมีจิตบริการสาธารณะ", percentage: 25, no: 3 },
  { id: 3, label: "การประสานความร่วมมือร่วมใจ", percentage: 25, no: 4 },
  { id: 4, label: "ความยืดหยุ่น คล่องตัว ริเริ่มสร้างสรรค์", percentage: 25, no: 5 },
];

const EXPERT_ROWS = [
  { id: 1, label: "การสื่อสารและการสร้างความผูกพัน", percentage: 25, no: 2 },
  { id: 2, label: "การเรียนรู้และพัฒนา", percentage: 25, no: 3 },
  { id: 3, label: "การปฏิรูป/ปรับเปลี่ยนราชการสู่อนาคต", percentage: 25, no: 4 },
  { id: 4, label: "การรักษาวินัย คุณธรรม และจริยธรรม", percentage: 25, no: 5 },
];

// รอบสุดท้ายที่ยังใช้สมรรถนะชุดเก่า (BASE_ROWS_OLD) คือ ปีงบประมาณ 2569 รอบ 1
// ปี 2569 รอบ 2 เป็นต้นไป และปีหลังจากนี้ ใช้สมรรถนะชุดใหม่ (BASE_ROWS/EXPERT_ROWS)
const OLD_ROWS_LAST_BUDGET_YEAR = 2569;
const OLD_ROWS_LAST_ROUND = 1;

// คืน true = ใช้สมรรถนะชุดเก่า
// - ปีงบประมาณก่อน 2569 : ใช้ชุดเก่าทุกรอบ
// - ปีงบประมาณ 2569     : ใช้ชุดเก่าเฉพาะรอบ 1
// - ปีงบประมาณ 2569 รอบ 2 เป็นต้นไป : ใช้ชุดใหม่
// ถ้าอ่านปีงบประมาณไม่ได้ (undefined/ค่าว่าง เช่น ตอน props ยังโหลดไม่เสร็จ) จะถือว่าเป็นชุดใหม่
export function shouldUseOldBehaviorRows(budgetYear, round) {
  
  const year = Number(budgetYear);
  if (!Number.isFinite(year) || year === 0) return false;

  if (year < OLD_ROWS_LAST_BUDGET_YEAR) return true;
  if (year > OLD_ROWS_LAST_BUDGET_YEAR) return false;

  const roundNumber = Number(round);
  if (!Number.isFinite(roundNumber) || roundNumber === 0) return false;
  return roundNumber <= OLD_ROWS_LAST_ROUND;
}

export function createBehaviorRows(extended = false, userLevelId = null, useOldRows = false) {
  
  const rows = useOldRows ? BASE_ROWS_OLD : [8,7,2,1,9,3,11,10].includes(userLevelId) ? BASE_ROWS : EXPERT_ROWS
  
  return rows.map(row => ({
    ...row,
    score: "",
    ...(extended ? { evaluate_salary_behavior_id: "", step_active: "" } : {}),
  }));
}
